module.exports = __webpack_public_path__ + "static/media/brujula-it.b82ef72a.svg";